import { render, staticRenderFns } from "./OrdersByStatusChart.vue?vue&type=template&id=b66cc974&scoped=true&"
import script from "./OrdersByStatusChart.vue?vue&type=script&lang=js&"
export * from "./OrdersByStatusChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66cc974",
  null
  
)

export default component.exports